module.exports = __webpack_public_path__ + "static/img/label-02.296d92b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/thaipost/label-02.png
// module id = bCrl
// module chunks = 150